module.exports = __webpack_public_path__ + "a73c22ee17a4a0800b24b92d062cabc9.woff2";